import { Building2 } from 'lucide-react';
import { formatDate } from 'shared_items/formatConventions';

const CardStaySummary = ({ stay, onClick }) => {
  const range =
    stay.checkin_date || stay.checkout_date
      ? `${stay.checkin_date ? formatDate(stay.checkin_date) : '—'} → ${
          stay.checkout_date ? formatDate(stay.checkout_date) : '—'
        }`
      : 'No dates';

  return (
    <button
      type="button"
      onClick={onClick}
      className="w-full text-left bg-white border border-gray-200 rounded-xl p-3 shadow-sm hover:bg-gray-50 hover:border-gray-300 transition flex gap-3"
    >
      <div className="w-10 h-10 rounded-lg bg-emerald-50 text-emerald-700 flex items-center justify-center flex-shrink-0">
        <Building2 className="h-5 w-5" strokeWidth={2} />
      </div>
      <div className="min-w-0 flex-1">
        <div className="flex items-center gap-2">
          <h4 className="text-sm font-semibold text-gray-900 truncate">
            {stay.name || 'Untitled stay'}
          </h4>
          {stay.status ? (
            <span className="text-[10px] uppercase tracking-wide px-1.5 py-0.5 rounded bg-gray-100 text-gray-600 flex-shrink-0">
              {stay.status}
            </span>
          ) : null}
        </div>
        <p className="text-xs text-gray-500 mt-0.5">{range}</p>
        {(stay.address || stay.platform) && (
          <p className="text-xs text-gray-400 mt-0.5 truncate">
            {[stay.platform, stay.address].filter(Boolean).join(' · ')}
          </p>
        )}
      </div>
    </button>
  );
};

export default CardStaySummary;
